import { Tooltip } from "antd";

import Image from "components/Image";
import ResignationStatusBadge from "./ResignationStatusBadge";
import {
  formatDay,
  fullName,
  isOverdue,
  noticeDays,
  noticeLabel,
  relativeDay,
} from "./resignationFormat";

export const PersonCell = ({ record, onOpen }) => {
  const person = record.company_user || {};
  const sub = [person.emp_no, person.position_name].filter(Boolean).join(" · ");
  return (
    <div className="resignation-person">
      <Image src={person.profile_image} type="user" alt="" className="resignation-person__avatar" style={{ width: 36, height: 36 }} />
      <div className="resignation-person__text">
        <button type="button" className="table-link resignation-person__name" onClick={() => onOpen(record)}>
          {fullName(person)}
        </button>
        <div className="resignation-muted">{sub || "-"}</div>
      </div>
    </div>
  );
};

/** First two lines in the cell; the whole letter on hover. */
export const ReasonCell = ({ reason }) => {
  if (!reason) return <span className="resignation-muted">No reason given</span>;
  return (
    <Tooltip
      placement="bottomLeft"
      mouseEnterDelay={0.3}
      styles={{ root: { maxWidth: 480 } }}
      classNames={{ root: "resignation-tooltip" }}
      title={<div className="resignation-reason-tooltip">{reason}</div>}
    >
      <div className="resignation-reason-clamp">{reason}</div>
    </Tooltip>
  );
};

export const LastDayCell = ({ record }) => {
  const overdue = isOverdue(record);
  const notice = noticeLabel(noticeDays(record));
  return (
    <div>
      <div className="fw-semibold">{formatDay(record.last_working_day)}</div>
      <div className={`resignation-muted ${overdue ? "is-danger" : ""}`}>
        {overdue ? `Passed ${relativeDay(record.last_working_day)}` : relativeDay(record.last_working_day)}
      </div>
      {notice && <div className="resignation-muted">{notice}</div>}
    </div>
  );
};

export const StatusCell = ({ record }) => (
  <div>
    <ResignationStatusBadge status={record.approval_status} />
    {record.approval_status === "pending" && record.current_approver && (
      <div className="resignation-muted mt-1">Awaiting {fullName(record.current_approver)}</div>
    )}
  </div>
);

export const AppliedCell = ({ value }) => (
  <div>
    <div>{formatDay(value)}</div>
    <div className="resignation-muted">{relativeDay(value)}</div>
  </div>
);

/** Phone layout: one tappable card per request, reason included. */
export const ResignationCard = ({ record, onOpen }) => (
  <button type="button" className="resignation-card" onClick={() => onOpen(record)}>
    <div className="resignation-card__top">
      <div className="resignation-person">
        <Image src={record.company_user?.profile_image} type="user" alt="" className="resignation-person__avatar" style={{ width: 36, height: 36 }} />
        <div className="resignation-person__text">
          <span className="resignation-person__name">{fullName(record.company_user)}</span>
          <div className="resignation-muted">{record.company_user?.position_name || "-"}</div>
        </div>
      </div>
      <ResignationStatusBadge status={record.approval_status} />
    </div>
    <div className="resignation-reason-clamp">{record.reason || "No reason given"}</div>
    <div className="resignation-card__dates">
      <div>
        <div className="resignation-muted">Last working day</div>
        <div className={`fw-semibold ${isOverdue(record) ? "text-danger" : ""}`}>{formatDay(record.last_working_day)}</div>
      </div>
      <div>
        <div className="resignation-muted">Applied</div>
        <div>{formatDay(record.created_at)}</div>
      </div>
    </div>
  </button>
);
